import App from './App.svelte';
// import App from './TestPage.svelte';


const app = new App({
	target: document.body,
});

export default app;